import React__default from 'react';
import { Button } from '../../atoms/Button.js';
import { TitleGroup } from '../TitleGroup.js';
import { SwitchFormField } from './FormFields/SwitchFormField.js';
import './FormTitle.scss';

/**
 * Maps HeadingLevel to appropriate Button size
 */
function getButtonSizeFromTitleLevel(titleLevel = 'subsection') {
    const levelMap = {
        page: 'large',
        section: 'medium',
        subsection: 'small',
        group: 'small',
        subgroup: 'small',
        minor: 'small',
    };
    if (typeof titleLevel === 'number') {
        if (titleLevel <= 2)
            return 'large';
        if (titleLevel <= 4)
            return 'medium';
        return 'small';
    }
    return levelMap[titleLevel] || 'medium';
}
/**
 * Internal component that creates the right component for TitleGroup.
 * Must be inside FormProvider to access form context.
 */
function TitleGroupRightComponent({ toggle, primaryButton, secondaryButton, titleLevel, }) {
    const hasCustomButtons = !!primaryButton || !!secondaryButton;
    const hasToggle = !!toggle && toggle.visibility !== 'hidden';
    if (!hasToggle && !hasCustomButtons) {
        return null;
    }
    const isSwitchDisabled = toggle?.visibility === 'disabled';
    return (React__default.createElement("div", { className: 'form-title-right--rev' },
        hasToggle && toggle && (React__default.createElement(SwitchFormField, { schemaField: toggle.fieldName, orientation: 'horizontal', className: 'title-group-toggle--rev', isDisabled: isSwitchDisabled, disabledTooltip: toggle.helpText || 'Managed by Ekho' })),
        hasCustomButtons && (React__default.createElement("div", { className: 'form-title-buttons--rev' },
            secondaryButton && (React__default.createElement(Button, { variant: 'outline', size: getButtonSizeFromTitleLevel(titleLevel), ...secondaryButton })),
            primaryButton && (React__default.createElement(Button, { variant: 'filled', size: getButtonSizeFromTitleLevel(titleLevel), ...primaryButton }))))));
}
/**
 * FormTitle component for rendering form headers with form-aware features.
 * Must be used inside a Form to access form context.
 *
 * @example
 * ```tsx
 * <Form schema={schema} onSubmit={handleSubmit}>
 *   <FormTitle
 *     title="Account Settings"
 *     description="Configure your preferences"
 *   />
 *   <FormItem schemaField="email">...</FormItem>
 * </Form>
 * ```
 */
function FormTitle({ title, description, level = 'subsection', tag, maxWidth, toggle, titleWeight = 'bold', primaryButton, secondaryButton, }) {
    return (React__default.createElement(TitleGroup, { title: title, description: description, level: level, titleWeight: titleWeight, tag: tag, maxWidth: maxWidth, rightComponent: React__default.createElement(TitleGroupRightComponent, { toggle: toggle, primaryButton: primaryButton, secondaryButton: secondaryButton, titleLevel: level }) }));
}
FormTitle.displayName = 'FormTitle';

export { FormTitle };
//# sourceMappingURL=FormTitle.js.map
